import { render, staticRenderFns } from "./PizzaLFilledIcon.vue?vue&type=template&id=3b06c8dd&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports